import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/ui/intended-audience/global.json'

export const INTENDED_AUDIENCE_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
